import { Component } from '@angular/core';
import { EboiStateService } from './service/eboi-state.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'lios-eboi-mfe';
  isAuthorized: boolean = false;
  AUthToken: boolean = false;
  clientHeight: number;
  constructor(private readonly state: EboiStateService) {
    this.clientHeight = window.innerHeight;
  }

  ngOnInit() {
    if (localStorage.getItem('toyotaGUID')) {
      this.AUthToken = true;
    }

    this.state.roleState.subscribe((value) => {
      if (value) {
        this.isAuthorized = true;
      }
    });
  }


}

